// Hari K:06-11-2023 :BT-119138:Funds View - Transaction filter modal - start
import { memo} from "react";
import { BzButton, BzChip,  BzInputText, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { handleModal } from "../../redux/actions/modals";

const TransactionFilterModal = ({ filterInputs, setFinalFilterInputs, setFilterInputs, }) => {

    const dispatch = useDispatch()
    const modals = useSelector(state => state.modals.modals);

    const onHide = () => {
        dispatch(handleModal([{ "TRANSACTION_FILTER_MODAL": false }]));
    };

    const handleFilterInputs = (filterName, filterValue) => {
        setFilterInputs(curr => { return { ...curr, [filterName]: filterValue } })
    }

    const handleResetObjFilters = () => { // Hari k:2023-12-20 making states empty 
        setFinalFilterInputs({ minAmount: '', maxAmount: '', funds: '' })
        setFilterInputs({ minAmount: '', maxAmount: '', funds: '' })
        dispatch(handleModal([{ "TRANSACTION_FILTER_MODAL": false }]));
    }

    const handleOnFilterApply = () => {
        dispatch(handleModal([{ "TRANSACTION_FILTER_MODAL": false }]));
        setFinalFilterInputs(filterInputs)
    }


    return (
        <>
            {/* SumitG-08-12-23 */}
            <BzModal show={modals['TRANSACTION_FILTER_MODAL']} onHide={onHide} data-testid="funds-transaction-filter-modal">
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={10} className='d-flex justify-content-start align-self-center'>
                                <div className='font-medium font-size4 color-text'>Filters</div>
                            </Col>
                            <Col md={2} className='d-flex justify-content-end align-self-center'>
                                <div data-testid='funds-transaction-filter-modal-close-icon' className='icon-16 icon-close icon-dark' onClick={onHide}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <Row className='g-0 mt-2 mb-3'>
                            <Col className='d-flex justify-content-start'>
                                <div data-testid='funds-transaction-filter-modal-amount-label' className='font-medium font-size3 color-text'>Amount</div>
                            </Col>
                        </Row>
                        <Row className='g-0 mb-4'>
                            <Col md={9} className='d-flex'>
                                <div className='multi-chips-wrap'>
                                    <BzChip className={`multi-chip me-2 mb-2`}>
                                        <Col className='d-flex align-items-center'>
                                            <div className='font-regular font-size2 color-text'>Min</div>
                                            <BzInputText data-testid='funds-transaction-filter-modal-amount-min-input' size='sm' type='number' className='p-0 bdr-none font-regular text-end' value={filterInputs?.minAmount?.length ? filterInputs?.minAmount : null} placeholder={filterInputs?.minAmount?.length ? filterInputs?.minAmount : "0"} onChange={(e) => { handleFilterInputs('minAmount', e.target.value) }} ></BzInputText>
                                        </Col>
                                    </BzChip>
                                    <BzChip className={`multi-chip me-2 mb-2`}>
                                        <Col className='d-flex align-items-center'>
                                            <div className='font-regular font-size2 color-text'>Max</div>
                                            <BzInputText data-testid='funds-transaction-filter-modal-amount-max-input' size='sm' type='number' className='p-0 bdr-none font-regular text-end' value={filterInputs?.maxAmount?.length ? filterInputs?.maxAmount : null} placeholder={filterInputs?.maxAmount?.length ? filterInputs?.maxAmount : '0'} onChange={(e) => { handleFilterInputs('maxAmount', e.target.value) }}  ></BzInputText>
                                        </Col>
                                    </BzChip>
                                </div>
                            </Col>
                        </Row>
                        <Row className='g-0 mb-3'>
                            <Col className='d-flex justify-content-start'>
                                <div data-testid='funds-transaction-filter-modal-funds-label' className='font-medium font-size3 color-text'>Funds</div>
                            </Col>
                        </Row>
                        <Row clasName='g-0'>
                            <Col className='d-flex'>
                                <BzChip data-testid='funds-transaction-filter-modal-funds-add-chip' onClick={() => { handleFilterInputs('type', 'A'); }} className={`multi-chip me-2 mb-3 text-capitalize ${filterInputs?.type === "A" ? 'active' : ''}`}>Add</BzChip>
                                <BzChip data-testid='funds-transaction-filter-modal-funds-withdrawal-chip' onClick={() => { handleFilterInputs('type', 'W'); }} className={`multi-chip me-2 mb-3 text-capitalize ${filterInputs?.type === "W" ? 'active' : ''}`}>Withdrawal</BzChip>
                                <BzChip data-testid='funds-transaction-filter-modal-funds-transfer-chip' onClick={() => { handleFilterInputs('type', 'AL'); }} className={`multi-chip me-2 mb-3 text-capitalize ${filterInputs?.type === "AL" ? 'active' : ''}`}>Transferred</BzChip>
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>
                <BzModalFooter className='bdr-none'>
                    <Container fluid className='m-0 p-0'>
                        <Row className='g-0 pb-2'>
                            <Col className='d-flex justify-content-end align-items-center'>
                                <BzButton data-testid='funds-transaction-filter-modal-reset-filters-button' className='btn btn-md btn-outline me-3' onClick={() => handleResetObjFilters()}>Reset Filters</BzButton>
                                <BzButton data-testid='funds-transaction-filter-modal-apply-filters-button' className='btn btn-md btn-primary' onClick={handleOnFilterApply}>Apply</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>
        </>
    )
}

export default memo(TransactionFilterModal)

// Hari K:06-11-2023 :BT-119138:Funds View - transaction filter modal - start